import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editAttachment } from 'action/article'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import AttachmentForm from 'view/page/dataset-management/component/attachments/attachment-form'
import FormModal from 'view/component/form-modal'
import * as NUMBER from 'constant/number'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.file_name} has been successfully edited${response.is_draft ? ' and saved as a draft.' : '.'}`,
  title: 'Attachment edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const EditAttachment = ({ attachment, editAttachment, submitting, articleUuid }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const handleClick = () => {
    setVisible(true)
  }
  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editAttachment(articleUuid, { ...values, uuid: attachment.uuid })
      setVisible(false)
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>Edit Attachment</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(attachment)
        }}
        title='Edit Attachment'
        visible={visible}
      >
        <AttachmentForm
          attachment={attachment}
          form={form}
        />
      </FormModal>
    </>
  )
}

EditAttachment.propTypes = {
  articleUuid: PropTypes.string,
  attachment: PropTypes.object,
  editAttachment: PropTypes.func,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.insightSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editAttachment: bindActionCreators(editAttachment, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditAttachment)
